export { collectButtonComponentParams } from './collector';
export { LandingButton } from './LandingButton';
export type { ButtonInfo, ButtonStrapiComponent } from './types';
